import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Estilos básicos
import "swiper/css/autoplay"; // Estilos de autoplay
import { Autoplay } from "swiper/modules"; // Importar desde swiper directamente
import "./BrandSwiper.css";

export const BrandSwiper = ({data}) => {
  return (
    <div className="container">
      <div className="row">
          <Swiper
            modules={[Autoplay]} // Registrar el módulo Autoplay
            autoplay={{ delay: 3000, disableOnInteraction: false }} // Configuración del autoplay
            slidesPerView={3} // Cantidad de slides visibles
            spaceBetween={20} // Espacio entre slides
            loop={true} // Activar el loop infinito
          >
            {data?data.map((brand) => (
             <SwiperSlide key={brand.id} className="swiper-slide">
                <img
                  src={brand.logo}
                  alt={brand.name}
                />
             </SwiperSlide>
            )): "Loading..."}
          </Swiper>
      </div>
    </div>
  );
};

/*export default BrandSwiper;*/



